// شعار الطباعة في المستندات الورقية (A4): كشوف الحسابات والتقارير وسندات
// الصرف. مصدره إعدادات النظام مرّة واحدة ([[usePrintLogo]])، فتغييره من
// الإعدادات يسري على كل القوالب بلا تعديل أي مستند.
//
// لا يُرسَم عنصر إطلاقاً عند عدم وجود شعار أو تعطيل خيار إظهاره — فلا تبقى
// مساحة فارغة في أعلى الورقة.
//
// الإظهار يتحكّم به صنف `.print-logo-wrap` في `index.css` (مخفيّ على الشاشة،
// ظاهر على الورق) — لا `.print-only` وحده، لأن بعض شاشات الطباعة لا تُعرّفه
// فكان الشعار سيظهر على الشاشة عندها. `screen` يُظهره على الشاشة للمعاينة.
import { usePrintLogo } from './useSettings.js';

export function PrintLogo({ className = '', screen = false }) {
  const { visible, url } = usePrintLogo();
  if (!visible) return null;
  return (
    <div
      className={`print-logo-wrap print-only${screen ? ' print-logo-screen' : ''}${className ? ` ${className}` : ''}`}
    >
      <img className="print-logo" src={url} alt="شعار المركز" />
    </div>
  );
}
